enum GroupingType {
  CONFIDENCE_LEVEL = 'confidence_level',
  NONE = 'none',
  OWNER = 'owner',
  STAGE = 'stage',
}

export default GroupingType;
